import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Autocomplete,
  TextField,
  Button,
  Card,
  CardContent,
  Typography,
  CircularProgress,
  Box,
} from "@mui/material";
import baseURL from "../config";

const InvoicesByAgentAndMonth = () => {
  const [agents, setAgents] = useState([]);
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [month, setMonth] = useState("");
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Fetch crewing agents on mount
  useEffect(() => {
    const token = localStorage.getItem("token");
    const fetchAgents = async () => {
      try {
        const res = await axios.get(
          `${baseURL}/api/crewingAgent/getApprovedCrewingAgent`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        const agentsArray = res.data.data || [];
        setAgents(
          agentsArray.map((agent) => ({
            id: agent._id,
            name: agent.agentName,
          }))
        );
      } catch (err) {
        console.error("❌ Error fetching agents:", err);
        setError("Failed to load crewing agents");
      }
    };
    fetchAgents();
  }, []);

  const fetchInvoices = async () => {
    if (!selectedAgent || !month) {
      setError("Please select Agent and Month");
      return;
    }

    try {
      setLoading(true);
      setError("");
      const res = await axios.get(
        `${baseURL}/api/crewingAgentinvoices/${selectedAgent.id}/${month}`
      );
      setInvoices(res.data);
      console.log("Fetched invoices:", res.data);
    } catch (err) {
      console.error("❌ Error fetching invoices:", err);
      setError("Failed to fetch invoices");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 600, mx: "auto", mt: 5, p: 3, boxShadow: 3, borderRadius: 2, bgcolor: "background.paper" }}>
      <Typography variant="h5" fontWeight="bold" align="center" mb={3}>
        Fetch Invoices
      </Typography>

      {/* Agent Dropdown */}
      <Autocomplete
        options={agents}
        getOptionLabel={(option) => option.name}
        value={selectedAgent}
        onChange={(event, newValue) => setSelectedAgent(newValue)}
        renderInput={(params) => <TextField {...params} label="Select Crewing Agent" variant="outlined" />}
        sx={{ mb: 2 }}
        isOptionEqualToValue={(option, value) => option.id === value.id}
      />

      {/* Month Input */}
      <TextField
        label="Month"
        type="month"
        value={month}
        onChange={(e) => setMonth(e.target.value)}
        variant="outlined"
        fullWidth
        sx={{ mb: 3 }}
      />

      {/* Fetch Button */}
      <Button
        variant="contained"
        color="primary"
        onClick={fetchInvoices}
        fullWidth
        disabled={loading}
        sx={{ mb: 2 }}
      >
        {loading ? <CircularProgress size={24} color="inherit" /> : "Fetch Invoices"}
      </Button>

      {error && (
        <Typography color="error" align="center" mb={2}>
          {error}
        </Typography>
      )}

      {/* Invoice List */}
      {invoices.length > 0 ? (
        invoices.map((inv) => (
          <Card key={inv._id} sx={{ mb: 2, bgcolor: "grey.50" }}>
            <CardContent>
              <Typography><strong>Invoice ID:</strong> {inv._id}</Typography>
              <Typography><strong>Amount:</strong> {inv.totalAgentAmount}</Typography>
              <Typography>
                <strong>Status:</strong>{" "}
                <span style={{ color: inv.status === "Paid" ? "green" : "orange", fontWeight: 600 }}>
                  {inv.status}
                </span>
              </Typography>
            </CardContent>
          </Card>
        ))
      ) : (
        !loading && (
          <Typography color="text.secondary" align="center">
            No invoices found.
          </Typography>
        )
      )}
    </Box>
  );
};

export default InvoicesByAgentAndMonth;
